// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1SDUz","content":"LayoutSettings_content__3HrXD"};